import logger from 'src/utils/logger/logger';
export default function init() {
  return new Promise(resolve => {
    setTimeout(() => {
      logger.debug("init device");
      resolve("done");
    });
  });
}



// WEBPACK FOOTER //
// ./src/devices/nagra/init.js